module.exports = "<div class=\"start-view coreModule\"> <div class=\"row\"> <div class=\"col-sm-10 col-sm-offset-1\"> <h1>This is the generic start/landing page for the SERF application</h1> <p>From here you should be redirected to the starting page configured for yor role. In case that you are not redirected appropriately, please select the desired page from the menu</p> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/authentication/component/startView/startView.html
// module id = vl73
// module chunks = 0